module.exports = __webpack_public_path__ + "static/media/map_marker.85c2a44c.svg";